/**
 * Wizard navigation. Back only.
 *
 * This component also rendered a Next button, so every step from 1 to 7
 * showed two of them. The step's own button is a form submit and runs that
 * step's validation; this one called nextStep() directly, so clicking the
 * lower of the two skipped validation and advanced with whatever the athlete
 * had typed still unchecked. The Enter-key handler in OnboardingPage targets
 * [data-onboarding-next], which each step still carries, so keyboard advance
 * is unaffected.
 *
 * Original note: Sprint S13.1.A — wizard navigation (Back / Next). Submit button is rendered
 * by Step8Submit, не here, so consent-gating стays self-contained.
 */
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";
import { useOnboardingStore } from "@/stores/onboardingStore";


export function OnboardingNavigation() {
  const { t } = useTranslation();
  const currentStepIndex = useOnboardingStore((s) => s.currentStepIndex);
  const prevStep = useOnboardingStore((s) => s.prevStep);

  const isFirst = currentStepIndex === 0;

  return (
    <div className="mt-8 flex flex-col-reverse gap-3 border-t border-cream-border pt-6 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
      <Button
        variant="secondary"
        onClick={prevStep}
        disabled={isFirst}
        type="button"
        className="w-full sm:w-auto"
      >
        {t("onboarding.nav.back")}
      </Button>

    </div>
  );
}
